import { cloneDeep } from 'lodash'
import { StateCreator } from 'zustand'

type TSessionUIElements = {
  UIElements: TSessionUIElementsDefinition
}
type TSessionUIElementsDefinition = {
  showWarning: boolean
  isLoadingUser: boolean
}
export type TUIElementsSessionState = TSessionUIElements & {
  setUIElements(UIElements: Partial<TSessionUIElementsDefinition>): void
  resetUIElements(): void
}

export const initialUIElementsSessionState: TSessionUIElementsDefinition = {
  showWarning: false,
  isLoadingUser: false,
}

const createUIElementsSessionSlice: StateCreator<
  TUIElementsSessionState,
  [['zustand/devtools', unknown]],
  []
> = (set) => ({
  UIElements: cloneDeep(initialUIElementsSessionState),
  setUIElements: (UIElements) =>
    set(
      (state) => ({
        UIElements: { ...state.UIElements, ...UIElements },
      }),
      undefined,
      {
        type: 'session UIElements',
        UIElements,
      },
    ),
  resetUIElements: () =>
    set(
      () => ({ UIElements: cloneDeep(initialUIElementsSessionState) }),
      undefined,
      {
        type: 'session resetUIElements',
      },
    ),
})

export default createUIElementsSessionSlice
